import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { useStore } from 'zens-store'

const styles = StyleSheet.create({
  input: {
    maxWidth: 400,
  },
})

interface Props extends Omit<SelectProps<string>, 'error'> {
  error?: string
  onChange?: (value: string) => void
}

const UserLanguage = (props: Props) => {
  const { error, onSelect, onChange, ...otherProps } = props
  const { i18n } = useStore()
  const { t } = useTranslation()

  const select = (value: string) => {
    onChange?.(value)
    onSelect?.(value)
  }

  const titleForLanguage = (language: string) => {
    switch (language) {
      case 'en':
        return t('English')
      case 'nl':
        return t('Dutch')
      default:
        return language
    }
  }
  return (
    <Select
      items={i18n.availableLanguages?.map((language) => ({
        value: language,
        title: titleForLanguage(language),
      }))}
      onSelect={select}
      filterSelected
      style={styles.input}
      error={!!error}
      {...otherProps}
    />
  )
}

export default UserLanguage
